import { createApi } from "@reduxjs/toolkit/query/react";
import { APIErrorResponse, baseQueryWithRedirect, UntransformedResponse } from "features/api/utils/apiUtils.ts";
import endpoints, { baseURL } from "data/api/v1/endpoints.ts";
import {
	GetAcknowledgementsPdfRequestParameters,
	GetAcknowledgementsPdfResponse
} from "types/api/pdf/getAcknowledgementsPdf.ts";

export const pdfApiSlice = createApi({
	reducerPath: "pdfApi",
	baseQuery: baseQueryWithRedirect(baseURL, false),
	endpoints: (builder) => ({
		generateAcknowledgementsPdf: builder.query<
			GetAcknowledgementsPdfResponse,
			GetAcknowledgementsPdfRequestParameters
		>({
			query: (params?: GetAcknowledgementsPdfRequestParameters) => ({
				url: endpoints.pdf.getAcknowledgementsPdf(params?.orderId, params?.layoutFormat),
				method: "GET",
				responseHandler: (response: Response) => (response.ok ? response.blob() : response.json())
			}),
			transformErrorResponse: (error: UntransformedResponse<APIErrorResponse>) => ({
				errors: error?.data?.errors,
				status: error?.status.toString()
			})
		})
	})
});

export const { useLazyGenerateAcknowledgementsPdfQuery } = pdfApiSlice;
